export default "__VITE_ASSET__Db$YWB8L__"